/* istanbul ignore file */
import FeedbackNoteTimelineRecordLayout from 'domain/people/employee/Timeline/feedback/shared/layout/FeedbackTimelineRecordLayout';
import CreateFeedbackForm from 'domain/people/employee/Timeline/feedback/form/CreateFeedbackForm';
import UpdateFeedbackForm from 'domain/people/employee/Timeline/feedback/form/UpdateFeedbackForm';
import { CREATE_EMPLOYEE_FEEDBACK } from 'domain/people/employee/Timeline/feedback/employeeFeedbackService';
import { TimelineRegistry, TimelineItem } from 'domain/people/employee/Timeline/types';

const useEmployeeFeedbackItem = (): TimelineRegistry => ({
  AddForm: CreateFeedbackForm,
  UpdateForm: UpdateFeedbackForm,
  isApplicable: (item: TimelineItem) => !!item.feedback,
  source: 'feedback',
  urlPostfix: 'feedbacks',
  RecordLayout: FeedbackNoteTimelineRecordLayout,
  name: 'Feedback',
  permissionToCheck: CREATE_EMPLOYEE_FEEDBACK,
});

export default useEmployeeFeedbackItem;
